export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./welcome.vue?vue&type=template&id=0729133a"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/welcome.vue?vue&type=template&id=0729133a
// module id = Rmep
// module chunks = 0